// client/src/services/productService.js

import { getImageUrl } from '../utils/image';

export function normalizeProduct(raw) {
  if (!raw) return raw;
  const product = { ...raw };
  product.groupId = product.groupId ?? product.group_id;
  delete product.group_id;
  product.oldPrice = product.oldPrice ?? product.old_price;
  delete product.old_price;

  if (product.imageUrls) {
    try { product.imageUrls = typeof product.imageUrls === 'string' ? JSON.parse(product.imageUrls) : product.imageUrls; }
    catch (e) { product.imageUrls = product.imageUrl ? [product.imageUrl] : []; }
  } else if (product.image_urls) {
    try { product.imageUrls = typeof product.image_urls === 'string' ? JSON.parse(product.image_urls) : product.image_urls; }
    catch (e) { product.imageUrls = product.imageUrl ? [product.imageUrl] : []; }
    delete product.image_urls;
  } else if (product.imageUrl || product.image_url) {
    product.imageUrls = [product.imageUrl || product.image_url];
  } else {
    product.imageUrls = [];
  }

  if (!product.imageUrl && product.imageUrls.length > 0) product.imageUrl = product.imageUrls[0];
  delete product.image_url;

  if (product.variants) {
    try { if (typeof product.variants === 'string') product.variants = JSON.parse(product.variants); }
    catch (e) { product.variants = []; }
    if (Array.isArray(product.variants)) {
      product.variants = product.variants.map(v => ({
        ...v,
        retailPrice: v.retailPrice ?? 0,
      }));
    }
  }
  return product;
}

/**
 * Возвращает розничную цену с учётом варианта или товара.
 * Сервер всегда передаёт retailPrice, поэтому клиентский расчёт не используется.
 */
export function getRetailPrice(product, variant) {
  if (variant?.retailPrice) return variant.retailPrice;
  if (product.retailPrice) return product.retailPrice;
  return 0;
}

export function calculateDiscount(price, oldPrice) {
  if (!oldPrice || oldPrice <= price) return 0;
  return Math.round((1 - price / oldPrice) * 100);
}

export function getDiscount(product, price) {
  if (product.discountPercent != null) return product.discountPercent;
  return calculateDiscount(price, product.oldPrice);
}

export function getMainImage(product) {
  return getImageUrl(product);
}

export function getAvailableVariants(variants) {
  if (!variants || !Array.isArray(variants)) return [];
  return variants.filter(v => v.stock > 0);
}

export function prepareProductCard(raw) {
  const product = normalizeProduct(raw);
  const displayPrice = getRetailPrice(product);
  const discountPercent = getDiscount(product, displayPrice);
  const availableVariants = getAvailableVariants(product.variants);
  const mainImage = getMainImage(product);
  return { ...product, displayPrice, discountPercent, availableVariants, mainImage };
}

export function prepareProductPage(raw, selectedVariant) {
  const product = normalizeProduct(raw);
  const displayPrice = getRetailPrice(product, selectedVariant);
  const discountPercent = getDiscount(product, displayPrice);
  const availableVariants = getAvailableVariants(product.variants);
  return { ...product, displayPrice, discountPercent, availableVariants, selectedVariant };
}